import { Home } from './pages/home'

class App {
  constructor() {

    if(document.querySelector('.home')) {
      const home = new Home;
    }
  }
}

window.onload = function() {
  let app = new App();
};
